import { Breakpoints, styled } from "@vw-marketing/us-components";


export const StyledFilterDealerContainer = styled.div`
${() => `
    display: flex;
    flex-direction: column;
    .label-wrapper {
        margin-bottom: 17px;
    }
    @media (min-width: ${Breakpoints.b960}px) {
        padding: 50px 50px 0px 50px;
    }
`}
`

export const StyledDealersContainer = styled.div`
${() => `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 15px;
    max-height: 220px;
    overflow-y: scroll;
    scroll-behavior: smooth;
    justify-content: space-between;
    & > * {
        width: 100%;
    }
    ::-webkit-scrollbar {
        width: 5px;
        border-radius: 2.5px;
    }
    ::-webkit-scrollbar-thumb {
        background: #d8d8d8;
        border-radius: 2.5px;
        height: 119px;
    }


    .location-dealer-label {
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
    }

    @media (min-width: ${Breakpoints.b960}px) {
        max-height: 180px;
        padding-right: 4px;
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        & > * {
            width: 50%;
        }
    }
`}
`
